import React from 'react';

export const TwinArrowIcon = ({ size = 28, color = '#007E47' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size + 1} viewBox="0 0 28 29" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7046 19.3342C22.7046 19.7691 22.352 20.1217 21.9171 20.1217L4.94535 20.1217C4.51043 20.1217 4.15785 19.7691 4.15785 19.3342C4.15785 18.8992 4.51043 18.5467 4.94535 18.5467L21.9171 18.5467C22.352 18.5467 22.7046 18.8992 22.7046 19.3342Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5256 24.7253C16.2181 24.4177 16.2181 23.9191 16.5256 23.6116L21.36 18.7772C21.6675 18.4697 22.1661 18.4697 22.4737 18.7772C22.7812 19.0848 22.7812 19.5834 22.4737 19.8909L17.6393 24.7253C17.3318 25.0328 16.8332 25.0328 16.5256 24.7253Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5258 13.943C16.8334 13.6354 17.332 13.6354 17.6395 13.943L22.4737 18.7772C22.7812 19.0848 22.7812 19.5834 22.4737 19.8909C22.1661 20.1985 21.6677 20.1986 21.3602 19.891L16.5258 15.0567C16.2183 14.7491 16.2183 14.2505 16.5258 13.943Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29558 9.66543C5.29558 9.23051 5.64815 8.87793 6.08307 8.87793L23.0548 8.87793C23.4897 8.87793 23.8423 9.23051 23.8423 9.66543C23.8423 10.1004 23.4897 10.4529 23.0548 10.4529L6.08307 10.4529C5.64815 10.4529 5.29558 10.1004 5.29558 9.66543Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4745 4.27432C11.7821 4.58186 11.7821 5.08048 11.4745 5.38802L6.64015 10.2224C6.33261 10.5299 5.834 10.5299 5.52646 10.2224C5.21892 9.91484 5.21892 9.41622 5.52646 9.10868L10.3608 4.27432C10.6684 3.96678 11.167 3.96678 11.4745 4.27432Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4743 15.0566C11.1668 15.3642 10.6682 15.3642 10.3606 15.0566L5.52646 10.2224C5.21892 9.91484 5.21892 9.41622 5.52646 9.10868C5.834 8.80115 6.33242 8.80105 6.63996 9.10858L11.4743 13.9429C11.7819 14.2505 11.7819 14.7491 11.4743 15.0566Z"
      fill={color}
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/TwinArrow.icon.jsx